import type { MouseEvent as ReactMouseEvent } from 'react';
import { Icon } from '@/components/Icon';
import { showContextMenu } from '@/shell/ContextMenu/ContextMenu';
import { trayMenu, volumeMenu } from '@/shell/ContextMenu/menus';
import { useSettingsStore } from '@/settings/store';
import { BalloonTip } from './BalloonTip';
import { Clock } from './Clock';
import css from './Tray.module.css';

export function Tray() {
  const soundEnabled = useSettingsStore((s) => s.soundEnabled);

  /**
   * The notification area answers with the taskbar's own menu — it is part of
   * the taskbar, and right-clicking the clock was another way to reach Cascade
   * Windows. The icons in front of it speak for themselves instead.
   */
  function handleContextMenu(event: ReactMouseEvent<HTMLDivElement>) {
    showContextMenu(event, trayMenu());
  }

  return (
    <div className={css.tray} onContextMenu={handleContextMenu}>
      <button
        type="button"
        className={css.trayButton}
        onContextMenu={(event) => showContextMenu(event, volumeMenu())}
        aria-label="Volume"
        aria-pressed={soundEnabled}
        title={soundEnabled ? 'Volume' : 'Volume (muted)'}
        onClick={() => useSettingsStore.getState().setSoundEnabled(!soundEnabled)}
      >
        <Icon
          src={soundEnabled ? '/assets/icons/volume.svg' : '/assets/icons/volume-muted.svg'}
          size={16}
        />
      </button>

      <Clock />
      <BalloonTip />
    </div>
  );
}
